import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { OnChange } from "react-final-form-listeners";
import classnames from "classnames";
import {
  Button,
  Card,
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

import RadioInput from "../common/RadioInput";
import TextInput from "../common/TextInput";
import CheckboxInput from "../common/CheckboxInput";
import { RootStoreContext } from "../../app/stores/rootStore";
import InfoMessage from "../common/InfoMessage";
import AddNodeModal from "./AddNodeModal";

import surveyQuestionType, {
  SurveyDetailFormValues,
  SurveyQuestionFormValues,
  ISurveyDetailsDto,
} from "../../app/models/survey";
import Loader from "../common/Loader";
import SurveyResponsesComponent from "./SurveyResponsesComponent";
import classNames from "classnames";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

export interface SurveyParams {
  meetingId: number;
  nodeId: number;
  surveyId: number | null;
}

const AddSurvey: React.FC<SurveyParams> = ({ surveyId, meetingId, nodeId }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme, allLanguages } = rootStore.commonStore;
  const {
    createSurvey,
    createSurveyODG,
    updateSurvey,
    LoadSurveyDetail,
    setView,
    surveyDetails,
    LoadSurveyResponses,
  } = rootStore.surveyStore;

  const [selectedNode, setSelectedNode] = useState("");
  const [selectedTitleNode, setSelectedTitleNode] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [formValues, setFormValues] = useState(new SurveyDetailFormValues());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [languages, setLanguages] = useState([0]);
  const [createdSurveyId, setCreatedSurveyId] = useState(0);
  // const [IsvisibleObbligatorioRispondere, setIsvisibleObbligatorioRispondere] =
  //   useState(false);
  const [t] = useTranslation(["surveys", "translation"], translationHookOptions);

  const clickModalOpen = () => {
    setIsModalOpen(true);
  };

  const SelectedNode = (key: string, title: string) => {
    setSelectedNode(key);
    setSelectedTitleNode(title);
    setIsModalOpen(false);
    formValues.questionsLanguages[0].question = title;
  };

  const toggle = (tab: string) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  useEffect(() => {
    const scrollableElement = document.querySelector(".surveyForm");
    if (scrollableElement) disableBodyScroll(scrollableElement);

    let intMeetingId = meetingId;
    let intSurveyId = surveyId;
    if (intSurveyId) {
      setEditMode(true);
      LoadSurveyDetail(intMeetingId, intSurveyId).then((dto) => {
        let temp = [0];
        surveyFormFunction(dto);
        dto.survey.questionsLanguages.forEach((l) => {
          temp.push(l.languageId);
        });

        setLanguages(temp.filter((x) => x > 0));
      });
    } else {
      setEditMode(false);
      LoadSurveyDetail(intMeetingId, 0)
        .then((dto) => surveyFormFunction(dto))
        .catch();
    }

    const surveyFormFunction = (dto: ISurveyDetailsDto) => {
      let surveyForm = new SurveyDetailFormValues({
        nodeId: dto.survey!.nodeId,
        surveyId: dto.survey!.surveyId,
        surveyQuestionTypeId: dto.survey!.surveyQuestionTypeId,
        isOpen: dto.survey!.isOpen,
        obligatoryAnswer: dto.survey!.obligatoryAnswer,
        quorumPercentual: dto.survey!.quorumPercentual,
        quorumInt: dto.survey!.quorumInt,
        maxNumberAnswer: dto.survey!.maxNumberAnswer,
        voteFrom: dto.survey!.voteFrom,
        voteTo: dto.survey!.voteTo,
        quorumType: dto.survey!.quorumType,
        categorySurvey: dto.survey!.categorySurvey,
        questionsLanguages: [],
        surveyQuestionId: dto.survey!.surveyQuestionId,
        canEdit: dto.survey!.canEdit,
        answers: dto.survey!.answers,
      });

      setSelectedNode(dto.survey.nodeId.toString());
      setSelectedTitleNode(dto.odgTitle);

      //Recupero eventuali domande del sondaggio
      if (dto.survey!.questionsLanguages.length > 0) {
        dto.survey!.questionsLanguages.forEach((l: any) => {
          surveyForm.selectedLanguages.push(l.languageId);
          surveyForm.questionsLanguages.push(
            new SurveyQuestionFormValues({
              languageId: l.languageId,
              question: l.question,
            })
          );
        });
      } else {
        dto?.meetingDetails.meetingLanguages.forEach((l: any) => {
          surveyForm.selectedLanguages.push(l.languageId);
          surveyForm.questionsLanguages.push(
            new SurveyQuestionFormValues({
              languageId: l.languageId,
              question: "",
            })
          );
        });
      }
      setFormValues(surveyForm);

      return () => {
        const scrollableElement = document.querySelector(".surveyForm");
        if (scrollableElement) enableBodyScroll(scrollableElement);
        setFormValues(new SurveyDetailFormValues());
        setSelectedTitleNode("");
        setSelectedNode("");
      };
    };
  }, [
    LoadSurveyDetail,
    meetingId,
    nodeId,
    surveyId,
  ]);

  const setSelectedNodeId = (key: string, state: any) => {
    const field = state.fields["nodeId"];
    field.change(key);
    state.formState.submitFailed = true;
  };

  if (!surveyDetails) return <Loader />;

  return (
    <>
      <FinalForm
        className="surveyForm"
        initialValues={formValues}
        mutators={{ setSelectedNodeId }}
        onSubmit={(values: SurveyDetailFormValues) => {
          let formToSend = new SurveyDetailFormValues({
            nodeId: values.nodeId,
            surveyId: values.surveyId,
            obligatoryAnswer: values.obligatoryAnswer,
            isOpen: values.isOpen,
            maxNumberAnswer: values.maxNumberAnswer,
            quorumPercentual: values.quorumPercentual,
            quorumInt: values.quorumInt,
            voteFrom: values.voteFrom,
            voteTo: values.voteTo,
            surveyQuestionTypeId: values.surveyQuestionTypeId,
            quorumType: values.quorumType,
            categorySurvey: values.categorySurvey,
            questionsLanguages: [],
            surveyQuestionId: values.surveyQuestionId,
            canEdit: values.canEdit,
            answers: values.answers,
          });
          formToSend.meetingId = meetingId;
          formToSend.maxNumberAnswer = parseInt(
            values.maxNumberAnswer.toString()
          );
          formToSend.quorumPercentual = values.quorumPercentual;
          formToSend.quorumInt = values.quorumInt;
          formToSend.voteFrom = parseInt(values.voteFrom.toString());
          formToSend.voteTo = parseInt(values.voteTo.toString());
          formToSend.obligatoryAnswer = values.obligatoryAnswer ? true : false;
          formToSend.surveyQuestionTypeId = parseInt(
            values.surveyQuestionTypeId.toString()
          );

          if (nodeId > 0 && values.categorySurvey === "ODG") {
            formToSend.nodeId = nodeId;
            formToSend.surveyQuestionTypeId = 1;
          }

          if (values.categorySurvey === "ODG" && selectedNode !== "") {
            formToSend.nodeId = parseInt(selectedNode);
            formToSend.surveyQuestionTypeId = 1;
          }
          if (values.categorySurvey === "NON_ODG") formToSend.nodeId = 0;

          values.questionsLanguages.forEach((lts: any) => {
            if (values.selectedLanguages.includes(lts.languageId)) {
              formToSend.questionsLanguages.push(lts);
              formToSend.selectedLanguages.push(lts.languageId);
            }
          });
          if (createdSurveyId > 0 && editMode === false) {
            updateSurvey(createdSurveyId, formToSend).then(() =>
              LoadSurveyResponses(
                meetingId,
                surveyDetails.survey.surveyQuestionId
              )
            );
          }

          if (editMode === true && values.surveyId && values.surveyId > 0) {
            updateSurvey(values.surveyId, formToSend).then(() =>
              LoadSurveyResponses(
                meetingId,
                surveyDetails.survey.surveyQuestionId
              )
            );
          }
          if (createdSurveyId === 0 && editMode === false) {
            if (values.categorySurvey === "NON_ODG") {
              createSurvey(formToSend)
                .then((surveyId) => {
                  if (surveyId) setCreatedSurveyId(surveyId);
                  if (
                    formToSend.surveyQuestionTypeId === surveyQuestionType.Free
                  )
                    setView("list");
                })
                .catch((error) => ({
                  [FORM_ERROR]: error,
                }));
            } else {
              // proviene dal menù odine del giorno
              createSurveyODG(formToSend)
                .then((surveyId) => {
                  if (surveyId) setCreatedSurveyId(surveyId);
                })
                .catch((error) => ({
                  [FORM_ERROR]: error,
                }));
            }
          }

          setFormValues(formToSend);
          let temp = [0];
          formToSend.questionsLanguages.forEach((l) => {
            temp.push(l.languageId);
          });
          setLanguages(temp.filter((x) => x > 0));
        }}
        validate={(values) => {
          let errors = {};
          let errorNum = 0;
          if (
            values.selectedLanguages.length > 0 &&
            !values.selectedLanguages.includes(parseInt(activeTab))
          )
            setActiveTab(values.selectedLanguages[0].toString());
          values.selectedLanguages.forEach((l: number) => {
            let ql = values.questionsLanguages.filter(
              (x) => x.languageId === l
            )[0];
            if (!ql || !ql.question) {
              errorNum++;
            }
          });
          if (values.categorySurvey === "ODG" && selectedNode === "0")
            errorNum++;
          if (values.categorySurvey === "ODG" && !values.quorumType) errorNum++;
          if (
            values.categorySurvey === "NON_ODG" &&
            !values.quorumType &&
            values.surveyQuestionTypeId !== 4
          )
            errorNum++;
          //  if(!values.quorumType){
          //  errorNum++;
          //  }
          if (values.categorySurvey === "") errorNum++;
          if (values.categorySurvey === "NON_ODG") {
            // sondaggio libero 4
            if (values.surveyQuestionTypeId === 0) errorNum++;
            if (
              values.surveyQuestionTypeId !== 4 &&
              (values.quorumPercentual < 0 || values.quorumInt < 0)
            )
              errorNum++;
            // caso  sondaggio multiplo
            if (values.surveyQuestionTypeId === 2 && values.maxNumberAnswer < 2)
              errorNum++;
            // if (

            //   values.maxNumberAnswer < 1
            // )
            //   errorNum++;
            // caso  sondaggio per votazione
            if (
              values.surveyQuestionTypeId === 3 &&
              (values.voteTo <= 0 || values.voteTo <= values.voteFrom)
            )
              errorNum++;
          }

          if (errorNum === 0) return errors;
          else return { count: errorNum };
        }}
        render={({
          handleSubmit,
          invalid,
          pristine,
          values,
          form,
        }) => (
          <Form onSubmit={handleSubmit} fluid="true">
            <Row className="mb-3">
              <Col sm={3} className="">
                <Button
                  onClick={() => setView("list")}
                  className={classNames(
                    "surveyButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                  )}
                >
                  <span className="btn-inner--icon">
                    <i className="fas fa-arrow-left" />
                  </span>
                  <span className="btn-inner--text"> {t("back", { ns : "translation" })}</span>
                </Button>
              </Col>
              <Col sm={2} className="ml-auto">
                <div className="float-right mb-1">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      caret
                      color="default"
                      className="ml-0 surveyButton"
                    >
                      <i className="fas fa-globe mr-2"></i>
                      {t("languages", { ns : "translation" })}
                    </DropdownToggle>
                    <DropdownMenu>
                      {allLanguages.map((l) => (
                        <li key={l.id} className="dropdown-item">
                          <Field
                            disabled={
                              surveyDetails?.meetingDetails!.meetingLanguages.findIndex(
                                (lm) => lm.languageId === l.id
                              ) > -1
                                ? true
                                : false
                            }
                            key={l.id}
                            id={l.name}
                            name={`selectedLanguages`}
                            type="checkbox"
                            component={CheckboxInput}
                            value={l.id}
                            className="d-inline mr-2"
                          />
                        </li>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <FormGroup className="mb-2">
                  <label
                    className="form-control-label mr-3 modalLabel"
                    htmlFor="quorumType"
                  >
                    {t("create_edit_form_category_label")}
                  </label>
                  <div className="form-check-inline">
                    <div className="mr-2 form-inline">
                      <Field
                        name={`categorySurvey`}
                      >
                        {(props) => (
                          <div>
                            <label
                              className={classNames(
                                "btn btn-secondary surveyRadioButton",
                                values.categorySurvey === "NON_ODG"
                                  ? `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                                  : "surveyRadioButtonColor"
                              )}
                              form={"id1_NON_ODG"}
                            >
                              <input
                                className={"d-none"}
                                name={`categorySurvey`}
                                id={"id1_NON_ODG"}
                                type="radio"
                                value="NON_ODG"
                                onChange={props.input.onChange}
                              ></input>
                              {t("survey_list_table_category_filter_generic")}
                            </label>
                          </div>
                        )}
                      </Field>
                    </div>
                  {(surveyDetails.canViewODG ||  surveyDetails.survey.categorySurvey==="ODG")
                   && (<>

                      <div className="form-inline">
                      <Field
                        name={`categorySurvey`}
                      >
                        {(props) => (
                          <div>
                            <label
                              className={classNames(
                                "btn btn-secondary surveyRadioButton",
                                values.categorySurvey === "ODG"
                                  ? `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                                  : "surveyRadioButtonColor"
                              )}
                              form={"id1_ODG"}
                            >
                              <input
                                className={"d-none"}
                                name={`categorySurvey`}
                                id={"id1_ODG"}
                                type="radio"
                                value="ODG"
                                onChange={props.input.onChange}
                              ></input>
                              {t("survey_list_table_category_filter_odg")}
                            </label>
                          </div>
                        )}
                      </Field>
                      {(values.categorySurvey === "ODG" &&  surveyDetails.canViewODG)&&(
                        <Button
                          className={classNames(
                            "buttonScegliVoce btn-sm",
                            `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                          )}
                          onClick={() => clickModalOpen()}
                          // hidden={  nodeId>0? "hidden": ""}
                        >
                          <i className="fas fa-plus" />
                          <span className="btn-inner--text">
                            {" "}
                            {t("create_edit_form_doc_button")}
                          </span>
                        </Button>
                      )}
                    </div>
                   
                   
                   </>)}
                 

                    {/* )} */}
                    {/* {nodeId=== 0 && ( */}
                  </div>

                  {/* Serve per il Mutator, per capire quando viene selezionato un nodo diverso */}
                  <div className="mr-2">
                    <Field
                      name={`nodeId`}
                      id={"id1_NON_ODG"}
                      type="hidden"
                      component={TextInput}
                      label="GENERICO"
                      value={`nodeId`}
                    />
                  </div>

                  {/* )} */}
                  <OnChange name="categorySurvey">
                    {(value, previous) => {
                      if (value === "ODG" && surveyId! === 0) {
                        setIsModalOpen(true);
                      }
                      if (value === "ODG" && surveyId! > 0) {
                        setIsModalOpen(false);
                      }
                      if (value === "NON_ODG" && surveyId! === 0) {
                        setIsModalOpen(false);
                        setSelectedNode("");
                        setSelectedTitleNode("");
                      }
                      if (value === "NON_ODG" && surveyId! > 0) {
                        // setSelectedNode("");
                        // setSelectedTitleNode("");
                      }
                      if (nodeId > 0) {
                        setIsModalOpen(false);
                      }
                    }}
                  </OnChange>
                </FormGroup>
              </Col>
            </Row>

            <div></div>
            {values.categorySurvey === "ODG" && selectedNode && (
              <>
                <Row>
                  <Col sm={12}>
                    <h6 className="modalLabel mb-2">
                      {" "}
                      {t("create_edit_form_doc_label")} <b>{selectedTitleNode} </b>{" "}
                    </h6>
                  </Col>
                </Row>
              </>
            )}

            {values.categorySurvey === "NON_ODG" && (
              <div>
                <Row className="mb-2">
                  <Col xs={12} xl={12}>
                    <FormGroup className="mb-1 form-inline">
                      <label
                        className="form-control-label modalLabel mr-3"
                        htmlFor="surveyQuestionTypeId"
                      >
                        {t("create_edit_form_type_label")}
                      </label>
                      <Field
                        id="surveyQuestionTypeId"
                        name="surveyQuestionTypeId"
                        component="select"
                        className="form-control-alternative form-control  form-control-sm surveyFormText"
                        autoComplete="off"
                        parse={(value) => (value ? parseInt(value) : 0)}
                      >
                        <option value={0}>{t("create_edit_form_type_option")}</option>
                        {surveyDetails.surveyTypes!.length > 0 &&
                          surveyDetails.surveyTypes!.map((item) => (
                            <option
                              key={item.id}
                              value={item.id}
                              className="surveyFormText"
                            >
                              {t(item.name)}
                            </option>
                          ))}
                      </Field>
                    </FormGroup>
                  </Col>
                </Row>
                {values.surveyQuestionTypeId === 2 && (
                  <Row>
                    <Col xs={12}>
                      <FormGroup className="form-inline">
                        <label
                          className="form-control-label modalLabel mr-3"
                          htmlFor="maxNumberAnswer"
                        >
                          {t("create_edit_form_answernum_label")}
                        </label>
                        <Field
                          min={2}
                          id="maxNumberAnswer"
                          name="maxNumberAnswer"
                          component={TextInput}
                          type="number"
                          className="form-control-alternative form-control-sm surveyFormText"
                          autoComplete="off"
                          parse={(value) => value && parseInt(value)}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
              </div>
            )}

            {/* MANDATORY ANSWER NOT IMPLEMENTED???? */}
            {/* {IsvisibleObbligatorioRispondere && (
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor={`obligatoryAnswer`}
                >
                  {t("create_edit_form_mandatory_label")}
                </label>
                <Field
                  name={`obligatoryAnswer`}
                  component={ToggleInput}
                  type="checkbox"
                  className="form-control-alternative"
                />
              </FormGroup>
            )} */}

            {values.categorySurvey === "NON_ODG" &&
              values.surveyQuestionTypeId === 3 && (
                <Row>
                  {/* POSSIBILITA DI INSERIRE SOLO IL VOTO MASSIMO */}
                  {/* <Col xl={4}>
                    <FormGroup>
                      <label className="form-control-label" htmlFor="voteFrom">
                        Voto minimo
                      </label>
                      <Field
                        id="voteFrom"
                        name="voteFrom"
                        component={TextInput}
                        type="number"
                        className="form-control-alternative form-control-sm"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col> */}
                  <Col xl={4}>
                    <FormGroup className="form-inline">
                      <label
                        className="form-control-label modalLabel mr-3"
                        htmlFor="voteTo"
                      >
                        {t("create_edit_form_maxvote_label")}
                      </label>
                      <Field
                        id="voteTo"
                        name="voteTo"
                        component={TextInput}
                        type="number"
                        className="form-control-alternative form-control-sm surveyFormText"
                        autoComplete="off"
                      />
                    </FormGroup>
                  </Col>
                </Row>
              )}

            {(values.categorySurvey === "ODG" ||
              (values.categorySurvey === "NON_ODG" &&
                (values.surveyQuestionTypeId === 1 ||
                  values.surveyQuestionTypeId === 2 ||
                  values.surveyQuestionTypeId === 3))) && (
              <Row className="col-12 mb-2">
                {/* <Col> */}
                <FormGroup className="mb-0 form-inline">
                  <label
                    className="form-control-label modalLabel mr-3"
                    htmlFor="quorumPercentual"
                  >
                    {t("create_edit_form_quorum_label")}
                  </label>
                  <div className="input-group input-group-sm">
                    <Field
                      min={0}
                      id="quorumPercentual"
                      name="quorumPercentual"
                      component={TextInput}
                      type="number"
                      className="surveyFormText form-control surveyQuorumInput "
                      autoComplete="off"
                      aria-describedby="basic-addon1"
                      parse={(value) => value && parseInt(value)}
                    />
                    {/* <div className="input-group-append">
                        <span className="input-group-text">%</span>
                      </div> */}
                  </div>
                </FormGroup>

                <FormGroup className="mb-0 form-inline">
                  <label className="form-control-label" htmlFor="quorum+">
                    <br></br>
                  </label>
                  <p style={{ fontSize: "1.5em" }} className="text-center mb-0">
                    <b className="mr-3 ml-1">%</b>
                    <b className="mr-2">+</b>
                  </p>
                </FormGroup>

                <FormGroup className="mb-0 form-inline mr-3">
                  <label className="form-control-label" htmlFor="quorumInt">
                    <br></br>
                  </label>
                  <Field
                    min={0}
                    id="quorumInt"
                    name="quorumInt"
                    component={TextInput}
                    type="number"
                    className="form-control-alternative form-control-sm surveyQuorumInput surveyFormText"
                    autoComplete="off"
                    parse={(value) => value && parseInt(value)}
                  />
                </FormGroup>

                <FormGroup className="mb-0 form-inline">
                  <label
                    className="form-control-label modalLabel mr-3"
                    htmlFor="quorumType"
                  >
                    {t("create_edit_form_of_label")}
                  </label>
                  <div className="form-check-inline">
                    <Field
                      name={`quorumType`}
                      id={"id1_Invitati"}
                      type="radio"
                      component={RadioInput}
                      label={t("create_edit_form_invited")}
                      value="Invitati"
                      labelClass="surveyFormText"
                    />
                    <div className="mr-2"></div>
                    <Field
                      name={`quorumType`}
                      id={"id1_Presenti"}
                      type="radio"
                      component={RadioInput}
                      label={t("create_edit_form_attending")}
                      value="Presenti"
                      labelClass="surveyFormText"
                    />
                  </div>
                </FormGroup>
                {/* </Col> */}
              </Row>
            )}

            {/* ------------------DROPDOWN SCELTA LINGUA--------------------- */}
            <Row>
              {/* </Row>
            <Row> */}

              <Col sm={10} lg={10}>
                <div className="modalLabel">{t("create_edit_form_question_label")}</div>
                <Nav tabs className="navQuestion">
                  {values.selectedLanguages &&
                    values.selectedLanguages.map((l) => (
                      <NavItem key={l.toString()}>
                        <NavLink
                          href="#"
                          className={classnames("surveyNavLinkResponse", {
                            active: activeTab === l.toString(),
                          })}
                          onClick={() => {
                            toggle(l.toString());
                          }}
                        >
                          <span
                            className={classnames(
                              "mr-1 flag-icon fa-2x",
                              allLanguages.filter((x) => x.id === l)[0].flagIcon
                            )}
                          ></span>
                          {/* {allLanguages.filter((x) => x.id === l)[0].name} */}
                        </NavLink>
                      </NavItem>
                    ))}
                </Nav>
                <TabContent activeTab={activeTab} className="pt-0 tabQuestion">
                  {values.selectedLanguages.length === 0 && (
                    <InfoMessage
                      color="primary"
                      message="Seleziona almeno una lingua"
                      icon="fas fa-globe fa-3x"
                    />
                  )}
                  {values.selectedLanguages &&
                    values.selectedLanguages.map((l, index) => (
                      <TabPane
                        key={l.toString()}
                        tabId={l.toString()}
                        className="tabPaneSurvey"
                      >
                        <Row>
                          <Col>
                            <Card className="questionCard ">
                              <Field
                                name={`questionsLanguages[${
                                  values.questionsLanguages.findIndex(
                                    (x) => x.languageId === l
                                  ) > -1
                                    ? values.questionsLanguages.findIndex(
                                        (x) => x.languageId === l
                                      )
                                    : values.questionsLanguages.length
                                }].languageId`}
                                component={TextInput}
                                placeholder="Nome"
                                type="hidden"
                                className="form-control-alternative"
                                autoComplete="off"
                                defaultValue={l}
                              />
                              <FormGroup className="mb-0">
                                <Field
                                  name={`questionsLanguages[${
                                    values.questionsLanguages.findIndex(
                                      (x) => x.languageId === l
                                    ) > -1
                                      ? values.questionsLanguages.findIndex(
                                          (x) => x.languageId === l
                                        )
                                      : values.questionsLanguages.length
                                  }].question`}
                                  component={TextInput}
                                  type="textarea"
                                  className="form-control-alternative"
                                  autoComplete="off"
                                />
                              </FormGroup>
                            </Card>
                          </Col>
                        </Row>
                      </TabPane>
                    ))}
                </TabContent>
              </Col>
              <Col xs={2} className="">
                <Button
                  disabled={invalid || pristine}
                  className={classNames(
                    "surveySubmitButton surveyButton",
                    `${theme!.buttonColor} ${theme!.buttonBorderColor} ${theme!.buttonTextColor}`
                  )}
                  type="submit"
                >
                  {t("save", { ns : "translation" })}
                </Button>
              </Col>
            </Row>

            {surveyDetails.survey.surveyId === 0 && (
              <Row>
                <Col sm={12}>
                  <small className="text-muted">
                    {t("create_edit_form_bottom_message")}
                  </small>
                </Col>
              </Row>
            )}
            {surveyDetails.survey.surveyId &&
            values.surveyQuestionTypeId !== surveyQuestionType.Free ? (
              <SurveyResponsesComponent
                languages={languages}
                survey={surveyDetails}
              ></SurveyResponsesComponent>
            ) : null}
            <AddNodeModal
              isOpen={isModalOpen}
              toggle={() => setIsModalOpen(!isModalOpen)}
              meetingId={meetingId}
              form={formValues}
              selectedNode={selectedNode}
              // action={SelectedNode}
              action={(key: string, title: string) => {
                SelectedNode(key, title);
                form.mutators.setSelectedNodeId(key);
              }}
            ></AddNodeModal>
          </Form>
        )}
      ></FinalForm>
    </>
  );
};

export default observer(AddSurvey);
